import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1055.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M5395 7359 c22 -10 49 -19 61 -19 11 0 25 -5 31 -11 11 -11 76 -38
153 -62 19 -6 37 -14 40 -17 5 -6 72 -30 83 -30 4 0 7 8 7 18 0 9 6 29 14 44
13 25 13 27 -13 36 -98 35 -273 64 -380 61 l-36 -1 40 -19z"/>
<path d="M5125 7354 c-117 -18 -247 -63 -395 -137 -36 -18 -49 -61 -25 -87 10
-11 27 -20 37 -20 18 0 89 -28 204 -80 23 -11 54 -22 68 -26 14 -3 29 -10 32
-15 3 -5 12 -9 21 -9 9 0 35 -10 59 -22 38 -18 47 -20 67 -9 39 21 71 11 77
-24 3 -20 15 -34 35 -44 17 -8 42 -20 57 -28 14 -7 38 -13 51 -13 14 0 29 -4
32 -10 13 -21 42 -9 85 35 24 25 49 45 56 45 6 0 44 35 85 78 40 42 85 86 99
97 l27 20 -18 43 c-18 41 -20 43 -51 37 -18 -3 -50 -6 -70 -8 -23 -1 -38 -7
-38 -14 0 -18 -30 -16 -37 3 -7 19 16 72 25 57 4 -6 30 -14 57 -18 62 -9 51 4
-25 29 -30 11 -59 22 -65 26 -5 3 -32 15 -60 25 -27 10 -54 21 -60 25 -5 4
-25 11 -42 15 -18 3 -33 11 -33 16 0 5 -13 9 -29 9 -17 0 -33 5 -36 10 -13 21
-32 10 -28 -17 5 -37 -8 -54 -34 -47 -19 5 -39 45 -35 67 1 4 1 7 0 6 -2 -1
-43 -7 -93 -15z m360 -84 c-3 -5 1 -10 10 -10 9 0 13 -4 10 -10 -9 -15 24 -58
48 -63 15 -3 11 -5 -11 -6 -25 -1 -32 -5 -30 -18 2 -15 -4 -18 -34 -17 -21 1
-38 -1 -38 -5 0 -3 -4 -23 -9 -43 l-9 -38 34 3 c19 1 35 7 36 12 0 6 2 15 3
20 2 6 3 16 4 23 0 6 6 12 11 12 6 0 10 -24 10 -54 l0 -54 -37 2 c-54 4 -120
24 -125 39 -2 6 -2 40 0 75 l4 62 59 0 c33 0 59 4 59 10 0 6 -9 10 -20 10 -14
0 -20 7 -20 24 0 24 11 34 38 35 7 1 10 -3 7 -9z m-125 -26 c0 -8 -5 -12 -10
-9 -6 4 -8 11 -5 16 9 14 15 11 15 -7z m-430 -45 c0 -19 5 -20 195 -13 138 5
195 4 195 -4 0 -16 -36 -24 -78 -18 -20 3 -93 2 -162 -2 l-125 -7 3 -30 c3
-38 -11 -60 -32 -52 -12 5 -15 14 -10 32 3 14 2 31 -4 38 -10 12 -14 66 -5 80
8 13 23 -3 23 -24z m420 11 c0 -5 -4 -10 -9 -10 -6 0 -13 5 -16 10 -3 6 1 10
9 10 9 0 16 -4 16 -10z m-535 -60 c-11 -5 -38 -8 -60 -8 l-40 1 45 7 c64 10
78 10 55 0z"/>
<path d="M6052 7150 l-19 -39 74 -71 c70 -66 93 -77 93 -46 0 27 39 64 62 60
13 -2 16 -1 8 2 -8 4 -23 16 -35 27 -19 18 -151 107 -159 107 -2 0 -13 -18
-24 -40z"/>
<path d="M4680 7090 c0 -6 10 -24 22 -40 16 -22 27 -29 42 -24 17 4 18 3 6 -5
-8 -5 -12 -13 -8 -16 4 -4 28 -32 55 -62 47 -54 147 -156 195 -201 24 -22 26
-22 64 -6 53 23 268 74 309 74 19 0 37 5 40 10 3 6 -2 10 -13 10 -11 0 -43 10
-71 21 -42 18 -56 20 -77 10 -14 -6 -36 -11 -49 -11 -21 0 -25 5 -25 28 0 24
-7 33 -42 50 -55 27 -135 62 -142 62 -3 0 -30 11 -60 25 -30 14 -59 25 -64 25
-5 0 -36 12 -68 26 -65 30 -114 40 -114 24z m170 -107 c0 -10 -20 -40 -20 -31
0 3 -3 13 -6 22 -4 11 -1 16 10 16 9 0 16 -3 16 -7z m274 -69 c23 -9 20 -21
-8 -28 -30 -7 -56 2 -56 20 0 14 36 19 64 8z"/>
<path d="M5973 7078 c-17 -8 -23 -20 -23 -45 0 -35 5 -39 30 -23 10 6 20 4 32
-7 23 -21 14 -33 -26 -33 -37 0 -52 13 -59 50 -3 20 -5 18 -6 -10 -1 -27 -4
-31 -11 -20 -5 8 -10 27 -10 41 0 21 -7 28 -39 37 -54 17 -53 17 -99 -30 -45
-45 -51 -58 -27 -58 18 0 19 -12 3 -28 -14 -14 -55 -16 -60 -3 -1 5 -24 -9
-50 -32 -26 -23 -61 -52 -78 -65 -16 -13 -30 -27 -30 -32 0 -4 23 -11 51 -15
28 -4 46 -10 40 -14 -7 -4 14 -19 50 -36 49 -22 65 -26 79 -17 14 9 21 8 30
-3 7 -8 22 -15 34 -15 27 1 163 34 171 42 4 3 2 23 -3 44 -13 50 -26 161 -18
153 6 -6 24 -84 35 -154 5 -32 11 -41 29 -43 13 -2 25 3 28 12 3 9 15 16 25
16 10 0 19 4 19 10 0 5 7 7 15 4 8 -4 15 -1 15 5 0 6 -4 11 -10 11 -5 0 -10 7
-10 15 0 11 -13 15 -54 15 -35 0 -56 5 -59 13 -4 10 13 14 74 15 69 1 80 -1
89 -18 9 -16 8 -20 -5 -20 -9 0 -14 -4 -11 -9 12 -19 -8 -43 -61 -68 -50 -25
-54 -29 -49 -55 7 -36 -8 -44 -23 -12 -13 30 -33 27 -42 -7 -7 -23 -7 -23 -8
-1 -1 32 -43 30 -61 -3 -7 -14 -17 -25 -22 -25 -4 0 -8 -4 -8 -9 0 -10 75 -61
90 -61 5 0 10 17 11 38 0 20 3 30 6 22 3 -8 10 -21 16 -28 11 -14 24 -3 92 84
17 21 46 54 66 74 64 65 69 77 54 120 -8 22 -35 58 -66 86 -30 27 -66 61 -82
77 -31 29 -40 31 -74 15z m-97 -129 c3 -6 14 -9 24 -6 24 6 30 -11 29 -86 -1
-50 -2 -56 -9 -31 -15 64 -17 67 -42 50 -43 -30 -58 -21 -58 34 0 46 2 50 24
50 14 0 28 -5 32 -11z"/>
<path d="M3972 7072 c-14 -9 -33 -67 -25 -76 3 -2 16 0 29 6 18 9 24 19 24 45
0 34 -5 39 -28 25z"/>
<path d="M4443 7031 c-105 -83 -212 -204 -264 -296 -18 -33 -37 -61 -41 -63
-4 -2 -8 -8 -8 -13 0 -5 -10 -26 -23 -47 -22 -35 -92 -206 -116 -282 -15 -49
-41 -225 -41 -282 0 -36 4 -48 15 -48 8 0 15 -9 15 -20 0 -12 7 -20 17 -20 9
0 13 -3 10 -7 -4 -3 -1 -13 6 -21 10 -13 9 -15 -8 -8 -53 21 -51 24 -54 -78
-2 -91 -1 -96 23 -117 26 -23 38 -51 12 -30 -11 9 -14 6 -18 -17 -2 -15 0 -42
4 -59 8 -30 10 -31 41 -22 17 5 43 9 57 9 14 0 41 10 60 22 l35 22 -35 7 c-45
9 -133 40 -100 35 21 -3 68 -14 137 -32 8 -2 5 -15 -10 -43 -12 -22 -20 -42
-17 -44 7 -6 101 7 233 34 116 23 118 24 113 49 l-6 25 16 -22 c20 -27 50 -30
62 -5 9 17 8 30 -8 67 -5 11 -11 37 -14 58 l-5 37 40 0 c21 0 39 -2 39 -4 0
-2 -9 -26 -20 -52 -12 -26 -18 -55 -14 -63 8 -18 11 -27 13 -40 0 -5 10 -13
22 -16 15 -5 32 2 62 26 23 18 44 37 45 41 2 4 9 8 17 8 7 0 18 7 26 16 10 12
10 20 1 35 -11 17 -8 23 15 47 l28 27 3 -30 c4 -35 19 -55 30 -39 4 6 34 32
67 59 33 26 78 65 99 86 22 22 45 39 52 39 6 0 14 7 18 15 3 8 2 15 -3 15 -5
0 -14 -7 -21 -15 -7 -8 -21 -15 -31 -15 -10 0 -20 -4 -23 -9 -3 -5 -38 -17
-78 -26 -40 -10 -76 -22 -79 -27 -6 -10 -141 -21 -254 -22 -57 -1 -60 0 -63
24 -8 80 -13 91 -33 85 -18 -6 -17 -3 6 31 30 44 31 54 5 54 -19 0 -178 -43
-210 -57 -8 -3 -18 -6 -21 -5 -3 0 -31 -3 -62 -7 -72 -10 -64 -1 16 20 53 13
62 19 61 37 -1 25 14 29 30 8 14 -18 92 -6 148 22 l36 19 -29 33 c-30 34 -36
50 -19 50 5 0 22 -18 36 -40 15 -22 30 -40 34 -40 4 0 20 35 35 78 15 42 51
125 80 183 l53 106 -5 82 c-8 114 -13 119 -93 82 -36 -16 -67 -27 -69 -25 -7
6 17 27 33 30 25 4 88 37 93 49 11 31 -24 214 -60 309 l-10 28 -18 -33 c-10
-19 -18 -45 -19 -59 0 -14 -9 -54 -20 -90 -11 -36 -27 -103 -35 -149 l-15 -85
32 -34 c25 -26 28 -32 11 -23 -12 6 -25 16 -28 21 -3 6 -15 10 -25 10 -15 0
-21 -13 -31 -70 -9 -51 -19 -78 -37 -95 -14 -14 -23 -27 -21 -29 13 -11 69
-24 69 -15 0 5 5 9 11 9 6 0 40 19 75 43 53 34 63 46 59 64 -7 28 23 21 48
-13 18 -24 18 -24 -10 -19 -22 4 -44 -6 -105 -50 l-78 -56 0 -48 c0 -30 4 -48
13 -49 6 -1 35 -6 62 -11 l50 -10 -60 3 c-70 3 -85 0 -85 -20 0 -8 -4 -14 -10
-14 -5 0 -10 -7 -10 -15 0 -8 -6 -12 -14 -9 -8 3 -22 1 -31 -4 -13 -7 -24 -2
-45 17 -25 24 -28 34 -32 111 -3 49 -2 75 3 62 9 -25 34 -29 42 -8 3 7 -1 23
-8 33 -12 18 -12 23 6 42 21 23 42 20 32 -4 -12 -32 18 -13 36 23 19 37 51
136 51 156 0 11 -54 46 -70 46 -10 0 -84 -151 -102 -209 -7 -23 -16 -41 -20
-41 -13 0 -9 30 6 58 29 54 96 198 96 207 0 6 -17 21 -38 35 -37 24 -82 66
-82 76 0 8 57 -28 92 -58 19 -16 41 -27 51 -24 9 2 15 1 12 -3 -4 -8 27 -41
52 -55 14 -8 34 53 59 179 17 88 27 179 18 155 -15 -35 -77 -169 -99 -215 -32
-63 -33 -41 -1 28 13 29 29 70 36 92 7 22 18 51 26 65 15 30 34 88 34 106 0
22 -15 17 -67 -25z m-238 -523 c21 -43 22 -48 6 -28 -20 24 -44 80 -36 80 3 0
16 -24 30 -52z m-85 -94 c0 -13 -4 -24 -10 -24 -5 0 -10 6 -10 13 0 6 -3 23
-7 37 -6 22 -5 24 10 11 9 -7 17 -24 17 -37z m-75 -44 c3 -5 1 -10 -4 -10 -6
0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m166 -32 c-7 -18 -6 -29 2 -37
14 -14 5 -14 -26 0 l-24 11 26 29 c29 33 35 32 22 -3z m-60 -94 c-12 -19 -21
-37 -21 -39 0 -3 12 -11 28 -19 31 -17 82 -60 82 -70 0 -18 -34 -2 -61 29 -17
19 -37 35 -44 35 -26 0 -25 32 3 66 35 44 39 43 13 -2z m333 -300 c5 -13 2
-15 -16 -10 -13 3 -27 6 -31 6 -5 0 -5 5 -2 10 10 16 42 12 49 -6z m-64 -33
c0 -4 -24 -20 -52 -35 l-53 -28 40 36 c39 34 65 45 65 27z m-365 -59 c-8 -8
-13 0 -20 33 l-7 30 16 -29 c9 -16 14 -31 11 -34z m374 -14 c1 -5 -3 -8 -9 -8
-5 0 -10 12 -9 28 0 24 1 25 9 7 5 -11 9 -23 9 -27z m451 22 c0 -5 -7 -7 -15
-4 -8 4 -15 8 -15 10 0 2 7 4 15 4 8 0 15 -4 15 -10z m-650 -15 c0 -8 -4 -15
-10 -15 -5 0 -10 7 -10 15 0 8 5 15 10 15 6 0 10 -7 10 -15z m95 -15 c3 -5 2
-10 -4 -10 -5 0 -13 5 -16 10 -3 6 -2 10 4 10 5 0 13 -4 16 -10z m-245 -52 c0
-49 -5 -47 -13 5 -3 20 -2 37 4 37 5 0 9 -19 9 -42z m215 -22 c13 -3 27 -15
30 -26 3 -11 11 -20 16 -20 5 0 9 -4 9 -9 0 -5 -17 -8 -37 -8 -23 1 -37 7 -36
14 2 6 -6 15 -17 18 -23 7 -25 18 -8 48 10 18 13 19 16 5 2 -9 14 -19 27 -22z
m25 -101 c0 -8 6 -15 13 -15 8 0 7 -4 -3 -10 -17 -11 -167 -14 -156 -3 4 4 26
9 48 10 23 2 51 9 62 17 27 19 36 19 36 1z"/>
<path d="M4628 7052 c-10 -2 -18 -6 -18 -10 0 -3 14 -73 32 -154 l32 -148 30
5 c60 12 86 -37 57 -109 -9 -23 -16 -27 -36 -24 -26 5 -31 -5 -26 -62 4 -51
10 -56 37 -27 14 15 31 27 39 27 8 0 15 4 15 9 0 5 32 32 70 61 39 29 70 53
70 54 0 1 -30 1 -67 1 -44 0 -68 4 -70 12 -4 10 17 11 87 8 126 -7 126 1 9
120 -52 51 -116 119 -144 150 -59 67 -94 93 -117 87z m21 -39 c0 -25 -1 -26
-9 -8 -12 27 -12 35 0 35 6 0 10 -12 9 -27z m21 -64 c0 -5 -4 -9 -10 -9 -5 0
-10 7 -10 16 0 8 5 12 10 9 6 -3 10 -10 10 -16z"/>
<path d="M6378 6925 c3 -24 13 -42 34 -57 16 -13 35 -28 41 -33 7 -6 25 -20
41 -33 26 -20 26 -22 8 -22 -11 0 -22 -8 -24 -17 -3 -13 -9 -7 -21 20 -9 20
-24 40 -34 44 -10 4 -25 14 -33 23 -11 13 -21 15 -39 8 -23 -8 -23 -9 -6 -28
18 -20 17 -20 -13 -20 -18 0 -32 -4 -32 -10 0 -5 4 -10 8 -10 5 0 37 -36 71
-81 34 -45 56 -79 49 -77 -7 3 -35 34 -63 70 -53 70 -95 103 -102 81 -3 -7
-26 -15 -53 -19 -42 -6 -53 -13 -100 -66 -29 -32 -51 -61 -49 -63 4 -3 48 -8
65 -6 6 1 22 26 35 56 13 30 27 55 32 55 13 0 8 -19 -18 -70 -14 -27 -25 -54
-25 -61 0 -8 30 -10 100 -8 87 3 101 2 113 -14 7 -11 40 -25 77 -34 63 -14 65
-14 81 6 19 23 53 27 94 11 45 -17 46 -2 8 68 -20 37 -44 83 -54 102 -9 19
-28 44 -41 56 -27 24 -119 130 -131 150 -14 25 -23 15 -19 -21z m146 -211 c9
-24 7 -64 -3 -64 -8 0 -31 52 -31 71 0 16 28 10 34 -7z"/>
<path d="M6195 6809 c-16 -30 -16 -30 4 -19 29 15 47 50 27 50 -9 0 -23 -14
-31 -31z"/>
<path d="M5797 6689 c25 -16 36 -18 52 -9 35 18 23 30 -31 30 l-53 0 32 -21z"/>
<path d="M6050 6613 c-29 -11 -70 -45 -65 -53 3 -5 11 -7 19 -4 7 3 18 -7 24
-21 12 -27 34 -33 49 -12 13 17 37 77 32 81 -10 8 -45 14 -59 9z"/>
<path d="M6106 6541 c-32 -81 -17 -95 89 -78 28 4 95 14 150 23 55 9 111 17
125 19 14 2 27 4 30 5 16 3 -56 31 -94 36 -41 6 -45 5 -48 -16 -5 -34 -26 -36
-30 -4 -4 32 -21 39 -132 49 l-73 7 -17 -41z"/>
<path d="M6625 6486 c-14 -20 -15 -32 -7 -55 9 -25 8 -32 -10 -43 -33 -22 -13
-38 45 -38 29 0 79 -7 110 -15 32 -8 93 -15 135 -15 43 0 115 -9 162 -21 47
-11 119 -22 161 -24 67 -4 83 -9 129 -39 43 -28 62 -35 101 -34 l48 1 -19 28
c-17 22 -18 29 -6 38 16 13 61 8 82 -10 8 -6 17 -10 20 -7 2 3 -8 13 -23 23
-24 16 -36 17 -112 8 -72 -9 -93 -8 -147 7 -34 10 -77 18 -95 18 -19 0 -54 5
-78 11 -25 5 -48 8 -52 5 -4 -2 -14 4 -21 15 -10 13 -31 21 -73 26 -73 9 -172
11 -203 5 -19 -4 -26 1 -36 31 -35 100 -79 134 -111 85z"/>
<path d="M6435 6458 c-44 -9 -132 -24 -195 -34 -63 -9 -116 -17 -117 -18 -2
-2 4 -24 13 -50 9 -26 13 -50 10 -53 -3 -4 -36 -5 -72 -4 -36 1 -71 -2 -77 -7
-7 -5 -55 -12 -107 -15 -106 -7 -157 -19 -188 -45 -12 -9 -39 -28 -61 -41 -59
-36 -59 -49 -3 -45 26 1 74 10 107 18 32 9 68 16 79 16 16 0 17 3 8 12 -20 20
-14 28 18 28 29 0 71 8 232 46 77 18 101 14 96 -17 -2 -16 -15 -25 -43 -34
-57 -17 -127 -54 -120 -64 2 -5 19 -11 37 -14 18 -2 66 -12 107 -21 71 -16 74
-16 107 4 18 12 59 25 91 29 32 5 98 15 146 22 48 7 90 16 93 21 3 4 18 8 33
8 15 0 38 9 51 20 13 11 28 20 33 20 6 0 4 -6 -5 -12 -9 -7 -19 -23 -22 -35
-6 -17 -2 -22 16 -25 13 -2 35 -2 49 0 24 4 26 7 25 53 -1 44 -3 49 -23 49
-13 0 -23 6 -23 13 0 9 -14 11 -52 7 -46 -4 -53 -8 -50 -24 3 -17 1 -18 -11
-8 -8 7 -21 10 -29 7 -9 -4 -18 1 -22 10 -5 13 -18 15 -78 11 -137 -8 -161
-15 -179 -50 -9 -17 -24 -33 -34 -34 -14 -3 -17 1 -13 27 4 25 1 31 -14 31
-62 0 88 76 169 86 47 6 56 10 64 33 5 14 23 34 39 43 33 19 39 43 13 50 -10
2 -54 -4 -98 -14z"/>
<path d="M6506 6384 c-19 -18 -14 -29 13 -37 27 -7 56 16 48 37 -8 20 -41 21
-61 0z"/>
<path d="M5335 6290 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M5555 6213 c-59 -14 -126 -35 -122 -39 6 -6 126 24 147 37 16 9 8 10
-25 2z"/>
<path d="M5390 6163 c-42 -16 -100 -57 -92 -65 9 -9 121 50 122 65 0 8 -8 8
-30 0z"/>
<path d="M7370 6141 c0 -17 75 -88 98 -94 36 -9 92 11 92 33 0 10 3 20 8 22 4
2 -3 14 -15 27 -23 24 -23 24 -23 3 0 -46 -94 -57 -116 -15 -6 13 -14 20 -17
16 -4 -3 -7 -1 -7 5 0 7 -4 12 -10 12 -5 0 -10 -4 -10 -9z"/>
<path d="M6470 6109 c-30 -12 -70 -27 -89 -34 -40 -15 -37 -17 52 -40 l69 -18
29 31 c16 17 29 36 29 41 0 6 5 11 10 11 6 0 10 7 10 15 0 21 -44 19 -110 -6z"/>
<path d="M6678 6123 c-10 -2 -18 -11 -18 -19 0 -16 -16 -19 -25 -4 -12 20 -36
9 -65 -32 -34 -46 -37 -58 -15 -58 9 0 29 -6 44 -14 15 -8 56 -17 89 -21 73
-6 77 1 32 63 -47 65 -35 63 25 -3 l55 -60 0 71 c0 56 -3 73 -16 78 -17 7 -79
6 -106 -1z"/>
<path d="M5171 6078 c-28 -23 -51 -45 -51 -50 0 -11 21 4 80 55 60 51 35 47
-29 -5z"/>
<path d="M5660 6052 c-30 -9 -56 -19 -58 -24 -2 -4 -8 -8 -12 -8 -11 0 -124
-66 -142 -83 -7 -6 -25 -18 -39 -25 -14 -8 -45 -31 -69 -53 -23 -21 -46 -39
-51 -39 -5 0 -9 -5 -9 -11 0 -6 12 -9 27 -7 25 3 27 0 29 -30 1 -22 -4 -36
-16 -42 -18 -10 -40 4 -40 26 0 18 -30 26 -36 9 -3 -8 -36 -33 -72 -56 -36
-23 -75 -51 -86 -62 l-21 -20 40 6 c22 4 71 22 109 42 77 40 98 38 46 -5 -46
-38 -118 -62 -185 -61 -41 0 -68 -7 -119 -33 l-67 -34 35 -6 c20 -4 64 0 103
9 37 8 88 20 113 26 25 5 61 20 80 33 19 13 46 27 60 31 14 4 39 20 55 35 17
16 69 53 117 83 83 52 96 67 57 67 -18 0 -39 46 -39 85 0 25 29 55 53 55 9 0
28 -11 41 -25 30 -30 42 -26 117 36 26 22 50 39 54 39 19 0 104 44 99 51 -8
14 -113 8 -174 -9z"/>
<path d="M2938 6045 c-33 -18 -67 -72 -69 -111 -8 -118 108 -202 195 -140 17
11 33 24 34 29 6 13 22 8 55 -17 90 -68 346 -185 497 -227 83 -23 285 -27 293
-5 4 10 -13 15 -76 20 -185 16 -389 80 -577 181 -47 25 -102 53 -123 62 -37
16 -38 17 -31 56 9 55 -28 129 -74 151 -40 20 -88 20 -124 1z m104 -62 c19
-17 25 -73 9 -73 -6 0 -11 -15 -13 -32 -3 -29 -7 -33 -34 -36 -27 -3 -35 2
-53 31 -29 47 -26 71 10 101 36 30 55 32 81 9z"/>
<path d="M5894 6012 c-83 -28 -294 -154 -294 -176 0 -8 2 -8 8 1 12 20 108 63
159 72 102 18 493 2 493 -20 0 -16 19 -9 24 9 4 10 23 24 44 32 l37 13 -51 17
c-41 14 -60 16 -95 8 -24 -6 -75 -11 -114 -12 -65 -1 -70 0 -67 19 6 31 12 32
33 6 10 -13 24 -20 31 -17 70 36 70 37 -19 60 -79 21 -92 20 -189 -12z"/>
<path d="M5290 5988 c-55 -35 -93 -57 -117 -70 -28 -14 -29 -34 -4 -48 16 -8
31 2 98 65 79 75 87 93 23 53z"/>
<path d="M3669 5967 c-19 -12 -40 -35 -47 -50 -7 -15 -18 -27 -25 -27 -8 0 -8
-3 1 -12 7 -7 12 -26 12 -42 0 -50 32 -92 78 -103 53 -14 83 -7 121 25 41 36
56 107 32 154 -20 40 -74 78 -111 78 -15 0 -42 -10 -61 -23z m99 -59 c29 -29
4 -108 -34 -108 -35 0 -54 20 -54 58 0 45 14 62 50 62 14 0 31 -5 38 -12z"/>
<path d="M6356 5918 c-21 -12 -20 -28 1 -44 27 -19 12 -25 -31 -12 -37 12 -40
11 -67 -20 -21 -23 -29 -43 -29 -70 0 -20 -9 -52 -20 -70 -11 -17 -29 -60 -40
-95 -11 -35 -42 -97 -68 -139 -61 -98 -223 -268 -279 -292 -24 -11 -43 -23
-43 -28 0 -4 -3 -7 -7 -6 -5 1 -44 -10 -88 -24 -129 -43 -231 -60 -315 -55
-114 8 -198 22 -274 46 -81 25 -86 25 -86 6 0 -17 -51 -94 -62 -95 -4 0 6 21
22 47 17 26 30 52 30 58 0 12 -36 41 -122 97 -31 20 -74 53 -96 72 l-40 36
-56 -21 -56 -22 -1 -46 c-1 -25 -2 -64 -1 -86 0 -24 -2 -30 -4 -15 -10 50 -11
50 -46 36 -37 -16 -80 -4 -107 27 -19 23 -37 21 -102 -12 -51 -26 -63 -28
-133 -23 -87 5 -96 -4 -48 -54 15 -16 32 -39 37 -51 28 -61 333 -353 369 -353
8 0 21 10 29 23 8 13 30 28 49 33 24 8 32 15 30 30 -2 17 -2 17 8 2 18 -29 40
-10 42 36 l1 41 6 -50 c7 -60 31 -72 51 -26 7 17 19 36 28 43 10 9 8 -1 -7
-28 -19 -34 -21 -45 -12 -63 7 -11 16 -21 20 -21 13 0 41 -88 41 -126 0 -30 3
-34 38 -39 20 -4 53 -15 72 -25 69 -35 212 -54 410 -54 226 1 266 10 286 67
17 50 46 87 63 82 7 -3 19 -1 26 5 9 8 15 8 20 0 3 -5 14 -10 23 -10 10 0 26
-12 37 -26 15 -20 25 -25 47 -20 41 8 182 80 263 134 115 77 117 84 36 85 -28
0 -51 4 -51 9 0 4 5 8 10 8 22 0 8 46 -20 68 -31 25 -76 90 -67 98 3 3 27 -20
53 -51 46 -54 104 -96 104 -76 0 11 59 36 67 28 8 -9 -23 -37 -43 -37 -13 0
-14 -3 -4 -15 7 -8 20 -15 30 -15 24 0 184 172 246 264 11 17 38 58 60 91 21
33 47 68 57 79 9 11 17 25 17 31 0 6 11 35 25 63 31 64 31 69 3 75 -20 4 -19
4 5 6 20 1 30 8 38 27 14 38 49 175 54 215 10 69 24 213 22 215 -1 1 -56 4
-122 8 l-120 6 -22 -34 c-18 -28 -21 -44 -16 -83 4 -38 2 -52 -11 -62 -9 -7
-16 -20 -16 -28 0 -15 -57 -103 -66 -103 -6 0 3 17 31 55 12 17 27 52 34 78
14 58 4 77 -40 77 -19 0 -29 5 -29 15 0 8 7 15 15 15 22 0 18 22 -10 60 -25
34 -51 43 -79 28z m222 -104 c-10 -10 -28 6 -28 24 0 15 1 15 17 -1 9 -9 14
-19 11 -23z m-230 7 c3 -8 -1 -12 -9 -9 -7 2 -15 10 -17 17 -3 8 1 12 9 9 7
-2 15 -10 17 -17z m340 -34 c2 -11 -2 -14 -17 -10 -22 5 -26 14 -14 27 10 10
28 1 31 -17z m65 -62 c10 -14 14 -25 8 -25 -5 0 -19 13 -31 30 -12 16 -15 27
-8 25 7 -3 21 -17 31 -30z m-389 -40 c-19 -30 -18 -29 -49 -9 -14 9 -32 13
-41 10 -9 -3 -21 -3 -27 1 -15 9 32 20 91 22 l42 1 -16 -25z m-71 -50 c24 -10
26 -13 12 -19 -27 -10 -41 -7 -63 13 -41 35 -23 37 51 6z m318 -45 c44 0 68
-22 49 -45 -7 -8 -17 -12 -23 -8 -25 15 -48 10 -46 -11 4 -54 -4 -56 -21 -6
-23 66 -26 100 -8 82 7 -7 29 -12 49 -12z m-203 -44 c-13 -19 -24 -33 -26 -31
-5 4 37 65 44 65 2 0 -6 -15 -18 -34z m-218 -42 c0 -8 -4 -12 -10 -9 -5 3 -10
10 -10 16 0 5 5 9 10 9 6 0 10 -7 10 -16z m8 -79 c0 -14 -4 -28 -9 -31 -10 -6
-12 17 -3 40 9 22 12 20 12 -9z m129 -5 c-7 -17 -13 -26 -15 -21 -3 10 15 51
22 51 3 0 -1 -14 -7 -30z m307 -8 c-6 -4 -13 -14 -16 -22 -3 -10 -6 -8 -10 8
-5 18 -2 22 15 22 13 0 17 -3 11 -8z m-214 -28 c7 -19 7 -31 -1 -40 -25 -30
-49 -10 -49 42 0 34 37 33 50 -2z m-140 -82 c0 -5 -7 -17 -15 -28 -15 -19 -20
-8 -9 20 6 17 24 22 24 8z m-266 -37 c16 -12 17 -15 4 -15 -8 0 -21 7 -28 15
-16 19 -1 19 24 0z m162 -1 c17 -4 25 -15 30 -40 8 -42 21 -52 39 -28 12 17
13 17 9 -6 -5 -30 -1 -36 56 -80 60 -45 70 -55 40 -40 -14 7 -27 16 -30 20 -5
8 -66 40 -75 40 -3 0 -19 -22 -36 -50 -17 -27 -33 -50 -35 -50 -10 0 -2 20 22
55 14 20 24 44 22 53 -2 8 -23 21 -48 28 -38 11 -46 11 -53 -1 -14 -25 -38
-45 -48 -39 -5 3 2 15 16 26 16 13 25 29 25 48 0 16 5 32 11 36 6 3 8 15 6 26
-4 14 -2 18 10 14 8 -3 26 -9 39 -12z m-196 -94 c0 -5 -11 -12 -25 -16 -14 -3
-25 -11 -25 -18 0 -6 -5 -4 -10 4 -12 19 -13 33 -1 25 5 -3 12 -1 16 5 8 13
45 13 45 0z m544 4 c17 -7 22 -44 6 -44 -9 0 -30 31 -30 44 0 8 5 7 24 0z
m-1771 -58 c-2 -3 -3 -13 -3 -22 0 -20 -39 -15 -53 8 -8 12 -7 21 3 32 11 14
16 15 34 3 12 -8 20 -17 19 -21z m39 -42 c-2 -55 -12 -54 -12 1 0 27 3 45 7
42 3 -4 6 -23 5 -43z m-155 14 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
1 -19z m1350 0 c33 -31 28 -43 -7 -18 -16 12 -30 26 -30 31 0 15 12 11 37 -13z
m-1687 -24 c0 -8 -4 -14 -10 -14 -5 0 -10 9 -10 21 0 11 5 17 10 14 6 -3 10
-13 10 -21z m1373 1 c7 -16 -8 -29 -23 -20 -15 9 -12 35 4 35 8 0 16 -7 19
-15z m118 -49 c-5 -6 -11 -29 -14 -51 -3 -29 -4 -23 -5 24 -2 56 0 62 13 51
10 -8 12 -17 6 -24z m49 3 c0 -18 -2 -19 -15 -9 -8 7 -15 16 -15 21 0 5 7 9
15 9 9 0 15 -9 15 -21z m210 2 c13 -25 13 -34 0 -26 -16 10 -32 45 -21 45 6 0
15 -9 21 -19z m-1493 -23 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m516 7 c-6 -17 -25 -15 -31 3 -2 7 5 12 17 12 14 0 19 -5 14 -15z m658 -1
c-18 -8 -41 -13 -50 -11 -22 5 25 26 59 26 23 -1 22 -2 -9 -15z m559 6 c0 -5
-4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m-1880
-63 c0 -31 -3 -38 -10 -27 -13 20 -13 83 0 75 6 -3 10 -25 10 -48z m578 43
c19 0 23 -3 13 -9 -7 -5 -22 -6 -33 -3 -12 3 -27 -4 -39 -17 -11 -12 -25 -19
-30 -15 -15 9 32 56 49 49 7 -3 26 -5 40 -5z m462 -25 c0 -5 -5 -3 -10 5 -5 8
-10 20 -10 25 0 6 5 3 10 -5 5 -8 10 -19 10 -25z m570 26 c0 -12 -29 -35 -36
-28 -11 10 5 37 21 37 8 0 15 -4 15 -9z m-806 -26 c-4 -8 -10 -15 -15 -15 -4
0 -6 7 -3 15 4 8 10 15 15 15 4 0 6 -7 3 -15z m-442 -54 c-5 -22 -6 -23 -12
-6 -4 10 -4 30 -2 44 5 22 6 23 12 6 4 -10 4 -30 2 -44z m-305 17 c-3 -8 -6
-5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m1263 -2 c0 -16 -24 -38 -33 -30
-8 9 11 44 23 44 6 0 10 -6 10 -14z m-1046 -17 c-3 -5 -10 -7 -15 -3 -5 3 -7
10 -3 15 3 5 10 7 15 3 5 -3 7 -10 3 -15z m501 15 c13 -6 14 -9 3 -16 -8 -6 5
-7 38 -4 47 6 52 4 57 -16 9 -31 -2 -41 -26 -25 -28 18 -80 33 -121 36 -20 1
-20 1 0 16 22 17 26 17 49 9z m-570 -28 c-16 -7 -66 -15 -110 -18 -89 -6 -85
-4 25 16 101 18 123 19 85 2z m1476 -35 c-19 -37 -51 -62 -51 -40 0 14 50 79
61 79 5 0 1 -17 -10 -39z m-1404 7 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m486 -13 c65 -9 56 -29 -14 -33 -62 -4 -66 -6 -50 -26 8 -9 34 -16
64 -18 68 -4 63 -22 -7 -26 -48 -3 -57 0 -87 28 -18 16 -37 30 -41 30 -5 0 -8
6 -8 14 0 21 60 56 79 46 9 -5 38 -12 64 -15z m431 19 c13 -5 14 -9 5 -20 -9
-11 -15 -11 -25 -3 -8 6 -11 15 -8 20 6 11 8 11 28 3z m173 -61 c-2 -16 -4 -5
-4 22 0 28 2 40 4 28 2 -13 2 -35 0 -50z m-108 -94 l33 -44 -38 42 c-47 50
-119 133 -119 137 0 7 95 -96 124 -135z m-149 101 c0 -5 -13 -10 -29 -10 -56
0 -79 -52 -41 -90 39 -39 72 -20 80 47 6 45 7 46 15 19 5 -19 3 -38 -8 -62
-20 -41 -57 -53 -92 -30 -41 27 -31 111 15 129 25 9 60 8 60 -3z m482 -67
c-17 -30 -101 -107 -109 -100 -6 7 107 126 115 121 2 -1 -1 -11 -6 -21z m-277
-93 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z
m-739 -36 c-5 -13 -10 -14 -18 -6 -6 6 -8 18 -4 28 5 13 10 14 18 6 6 -6 8
-18 4 -28z m71 4 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m273
-12 c0 -16 -18 -31 -27 -22 -8 8 5 36 17 36 5 0 10 -6 10 -14z m275 -67 c11
-1 2 -5 -20 -9 -43 -8 -59 -5 -49 12 3 5 16 7 28 4 11 -3 30 -6 41 -7z"/>
<path d="M3410 5858 c0 -28 8 -39 43 -61 23 -15 34 -16 62 -7 36 12 51 33 32
48 -28 22 -78 42 -107 42 -25 0 -30 -4 -30 -22z"/>
<path d="M5049 5837 c-26 -18 -76 -53 -112 -79 -35 -27 -67 -48 -71 -48 -3 0
-15 -9 -26 -20 -11 -11 -27 -20 -35 -20 -12 0 -69 -31 -105 -58 -11 -8 28 -22
61 -22 47 0 64 -17 42 -42 -19 -22 -5 -24 23 -3 10 8 26 15 35 15 8 0 28 14
44 30 26 27 27 30 9 30 -11 0 -24 -4 -29 -9 -6 -5 -24 -12 -42 -16 -29 -6 -31
-4 -26 17 11 49 15 54 24 30 8 -21 10 -22 37 -8 16 8 34 22 41 30 8 9 21 16
30 16 25 0 110 54 166 104 42 38 48 48 39 63 -18 28 -55 25 -105 -10z"/>
<path d="M5750 5620 c-8 -5 -12 -12 -9 -15 8 -8 39 5 39 16 0 11 -11 11 -30
-1z"/>
<path d="M4020 5560 c-20 -7 -16 -8 22 -9 26 -1 50 4 53 9 7 12 -38 12 -75 0z"/>
<path d="M4220 5540 c-101 -7 -120 -12 -120 -36 0 -16 76 -19 150 -4 25 5 69
14 99 19 30 6 59 15 65 21 11 11 -35 11 -194 0z"/>
<path d="M4000 5521 c0 -10 9 -30 20 -44 11 -14 20 -34 20 -45 0 -45 121 -53
234 -16 137 46 284 124 233 124 -10 0 -27 -5 -38 -10 -46 -25 -244 -60 -341
-60 -54 0 -98 3 -98 6 0 3 11 15 25 26 31 24 24 38 -21 38 -27 0 -34 -4 -34
-19z"/>
<path d="M4468 5440 c-81 -27 -194 -58 -252 -69 -58 -11 -115 -25 -126 -31
-26 -14 -22 -39 18 -104 l27 -45 88 -1 c78 0 96 4 158 32 67 30 69 32 69 67 0
44 21 77 55 85 21 5 25 12 25 41 0 19 5 35 10 35 6 0 10 -8 10 -18 0 -36 19
-41 71 -18 27 11 49 24 49 27 0 3 -13 15 -28 26 l-28 21 -146 -48z m2 -60 c0
-14 -38 -28 -100 -36 -46 -6 -50 -5 -50 14 0 17 7 22 43 25 85 7 107 7 107 -3z"/>
<path d="M5033 5483 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M5335 5455 c-25 -12 -26 -14 -5 -9 14 4 29 10 35 15 12 12 5 11 -30
-6z"/>
<path d="M4627 5395 c-15 -10 -17 -21 -12 -44 7 -35 22 -38 68 -15 44 23 43
21 17 49 -26 28 -46 31 -73 10z"/>
<path d="M3328 5273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3408 5273 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M4997 5273 c-10 -10 -8 -33 3 -33 5 0 14 9 20 20 8 15 8 20 -3 20 -8
0 -17 -3 -20 -7z"/>
<path d="M7144 4139 c-106 -13 -172 -69 -193 -164 -32 -143 37 -245 189 -279
86 -20 113 -30 133 -51 24 -24 22 -87 -4 -111 -30 -27 -126 -30 -226 -6 l-83
19 0 -77 0 -78 48 -10 c178 -38 329 -16 399 60 58 62 69 182 26 269 -23 45
-37 59 -81 81 -30 15 -86 34 -127 43 -85 19 -115 42 -115 89 0 56 28 71 129
70 47 -1 104 -6 125 -12 22 -6 43 -9 48 -6 4 3 8 34 8 70 0 60 -2 65 -26 74
-38 15 -191 26 -250 19z"/>
<path d="M2204 4122 c-119 -42 -194 -144 -215 -294 -32 -220 55 -396 219 -445
77 -22 237 -21 312 4 l55 18 3 202 c2 186 1 202 -15 206 -10 3 -74 4 -143 3
l-125 -1 -3 -72 -3 -72 68 -3 68 -3 1 -68 c0 -77 -8 -87 -73 -87 -82 0 -145
37 -180 104 -9 17 -18 66 -21 111 -6 110 14 182 65 224 55 45 109 54 223 37
52 -7 98 -12 103 -9 4 2 7 35 7 73 0 55 -3 69 -17 75 -10 4 -76 9 -148 12
-108 3 -139 1 -181 -15z"/>
<path d="M2748 4132 l-68 -3 0 -373 c0 -290 3 -375 13 -378 6 -3 42 -6 79 -7
56 -2 67 0 70 15 1 10 2 180 0 380 -2 275 -5 363 -15 366 -6 1 -42 2 -79 0z"/>
<path d="M2926 4132 c-9 -2 -16 -4 -16 -5 0 -21 113 -507 162 -702 l13 -50 60
-3 c100 -5 98 -7 133 120 17 62 41 153 53 201 12 49 25 85 30 80 4 -4 29 -91
55 -193 26 -102 52 -191 58 -199 7 -9 29 -12 78 -9 37 2 69 6 72 9 9 9 187
740 182 746 -6 7 -149 4 -155 -3 -5 -5 -21 -76 -36 -159 -15 -82 -33 -175 -40
-205 -7 -30 -16 -72 -20 -94 -3 -21 -8 -36 -11 -34 -2 3 -22 79 -44 169 -22
90 -46 186 -52 212 l-12 48 -75 -3 -76 -3 -11 -50 c-27 -112 -93 -357 -98
-362 -7 -8 -8 -5 -51 217 -21 107 -41 211 -46 232 l-9 36 -64 4 c-35 1 -71 2
-80 0z"/>
<path d="M3990 4128 c0 -2 -56 -169 -124 -373 -69 -203 -121 -374 -117 -378 4
-4 41 -7 82 -5 l74 3 19 60 c11 33 20 66 22 73 3 9 38 12 133 12 l130 0 15
-57 c25 -88 24 -88 106 -91 40 -2 77 1 81 5 5 5 -2 42 -16 83 -13 41 -57 174
-96 295 -39 121 -83 254 -98 295 l-27 75 -92 3 c-51 1 -92 1 -92 0z m134 -323
c20 -69 34 -130 30 -137 -6 -10 -140 -6 -151 5 -2 3 10 51 28 108 17 57 34
114 36 127 3 12 9 22 13 22 4 0 24 -56 44 -125z"/>
<path d="M4480 3756 l0 -376 26 -6 c45 -11 305 3 350 19 149 54 214 165 214
362 0 182 -50 284 -168 342 -55 27 -63 28 -239 31 l-183 4 0 -376z m344 205
c58 -36 81 -90 81 -191 0 -109 -9 -152 -42 -191 -36 -43 -80 -59 -158 -59
l-65 0 0 236 0 237 74 -5 c53 -4 84 -11 110 -27z"/>
<path d="M5314 4098 c-3 -18 -13 -46 -20 -63 -26 -61 -216 -646 -211 -651 9
-9 114 -17 139 -11 19 5 27 19 43 77 l19 70 123 0 c68 0 126 0 130 1 4 0 18
-34 31 -77 l23 -76 80 4 c43 3 81 7 83 9 2 2 -50 164 -115 359 -65 195 -118
363 -119 373 0 15 -12 17 -99 17 l-99 0 -8 -32z m180 -430 c-6 -9 -147 -11
-156 -2 -3 3 3 35 14 72 10 37 26 92 35 122 8 30 17 62 20 70 3 8 25 -45 49
-119 23 -74 41 -138 38 -143z"/>
<path d="M5712 4058 l3 -73 95 -3 95 -3 -3 -299 -3 -299 24 -6 c13 -4 48 -5
78 -3 l54 3 5 304 5 303 95 2 95 1 3 73 3 72 -276 0 -276 0 3 -72z"/>
<path d="M6469 4103 c-47 -123 -239 -715 -234 -723 3 -6 40 -10 81 -10 84 0
82 -1 107 102 l11 47 125 3 c126 3 151 -3 151 -36 0 -7 7 -36 15 -64 l16 -52
79 0 c43 0 81 4 84 8 3 5 -50 175 -117 378 l-122 369 -93 3 -92 3 -11 -28z
m111 -177 c0 -7 16 -66 36 -130 20 -65 34 -120 31 -122 -11 -11 -144 -16 -151
-6 -8 13 64 272 76 272 4 0 8 -6 8 -14z"/>
<path d="M7542 3838 c3 -331 5 -336 87 -411 106 -96 345 -81 424 25 57 77 62
110 62 403 l0 270 -77 3 c-69 3 -78 1 -79 -15 0 -10 0 -98 1 -196 2 -260 -6
-332 -41 -371 -25 -28 -33 -31 -87 -31 -50 0 -65 4 -86 24 -14 14 -30 41 -36
60 -5 20 -10 147 -10 284 l0 247 -81 0 -80 0 3 -292z"/>
<path d="M8232 3753 l3 -378 145 -3 c168 -4 244 9 299 48 49 36 74 90 79 170
4 79 -16 124 -70 159 l-37 23 31 26 c75 63 78 203 7 272 -55 52 -91 60 -282
60 l-177 0 2 -377z m323 212 c29 -28 31 -54 10 -94 -18 -36 -32 -41 -110 -41
l-63 0 -4 70 c-2 39 -1 75 0 80 2 6 35 10 73 10 61 0 73 -3 94 -25z m24 -301
c19 -22 22 -35 18 -67 -9 -63 -33 -79 -126 -85 l-79 -4 -4 86 c-2 49 1 92 7
98 6 6 39 8 85 5 66 -5 78 -9 99 -33z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
